import {getCompareSubjectsLight} from '@explorer/selectors/compare';
import {getSelectedItemTypes} from '@explorer/selectors/item-types';
import {getSelectedMosaicName} from '@explorer/selectors/mosaics';
import {getDateRanges} from '@explorer/selectors/search';
import {getSelectedSeriesId} from '@explorer/selectors/series';
import {
  getEnhanceFilters,
  getEnhanceMode,
  getProcess,
  getProcessColor,
} from '@explorer/selectors/tile-groups';
/**
 * Some values are stored as an object, where the keys are names
 *  and the value is boolean switches. This does not translate
 *  well into a schema which needs to be validated. The names can have
 *  any number of symbols and the objects can have any number of properties.
 * This will convert an object like:
 *  `{a: true, b: false}`
 * Into an array which means the same:
 *  `[{name: 'a', on: true}, {name: 'b', on: false}]`
 * This refactoring is easier to validate and prevents as malicious user
 * from injecting arbitrary properties and values.
 */
const objectToBooleanList = inObj =>
  Object.keys(inObj).map(name => ({name, on: !!inObj[name]}));

const pickFirst = v => (v && v.length > 0 ? v[0] : v);

const transforms = {
  'map.overlays': objectToBooleanList,
  itemTypes: objectToBooleanList,
  'results.selectedItems': objectToBooleanList,
  'folders.selectedItems': objectToBooleanList,
  'filters.ground_control': pickFirst,
  'filters.quality_category': pickFirst,
  'searchFilters.instruments': objectToBooleanList,
  'searchFilters.publishingStages': objectToBooleanList,
};

const selectors = {
  version: () => 1.1,
  itemTypes: getSelectedItemTypes,
  'search.dateRanges': getDateRanges,
  'compare.subjects': getCompareSubjectsLight,
  'series.selectedId': getSelectedSeriesId,
  'mosaics.selectedName': getSelectedMosaicName,
  'tiles.process': getProcess,
  'tiles.processColor': getProcessColor,
  'tiles.enhance.mode': getEnhanceMode,
  'tiles.enhance.filters.filterSaturation': st =>
    getEnhanceFilters(st).filterSaturation,
  'tiles.enhance.filters.filterBrightness': st =>
    getEnhanceFilters(st).filterBrightness,
  'tiles.enhance.filters.filterContrast': st =>
    getEnhanceFilters(st).filterContrast,
};

export default {
  transforms,
  selectors,
};
